module.exports = __webpack_public_path__ + "static/media/wizualizacja-130.05843edd.png";